import { useEffect, useRef } from 'react';
import { Translate } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import toolTipCloseIcon from '@assets/svg/tooltip-close.svg';
import exclaimationInfo from '@assets/images/info.png';
import { infoToolTipSpecialCase } from '@landing/PageBottom/constants';

interface InfoTooltipProps {
    id: string;
    ismobile?: boolean;
    openTooltipId: string | null;
    setOpenTooltipId: (id: string | null) => void;
    isDashboard?: boolean;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({
    id, ismobile, openTooltipId, setOpenTooltipId, isDashboard
}) => {
    const isOpen = openTooltipId === id;
    const tooltipRef = useRef(null);

    const tooltipHandler = (event: any) => {
        setOpenTooltipId(isOpen ? null : id);
        event.stopPropagation();
    };

    const handleClickOutside = (event: any) => {
        if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
            setOpenTooltipId(null);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    return (
        <>
            <button className={`info-tooltip-icon border-none bg-none p-0 cursor-pointer ${isDashboard ? '' : 'absolute'} ${isOpen ? 'top-[2.2%]' : 'top-[30%]'} right-10 border`} onClick={tooltipHandler}>
                <img alt="info" src={exclaimationInfo} />
            </button>
            <span className={`${ismobile ? 'mobiletooltip-text flex flex-col justify-items-end items-end w-[215px] ml-6 text-sm font-avenirProMedium border border-country-border-color rounded-[10px] pt-[10px] px-[15px] pb-[15px]' : 'tooltip-external-text'} ${isOpen ? 'visible' : 'hidden'}`} ref={tooltipRef}>
                <button className="info-tooltip-icon text-right" onClick={tooltipHandler}>
                    <img alt="info" className="tooltip-popup-close-icon" src={toolTipCloseIcon} />
                </button>
                {infoToolTipSpecialCase.includes(id) ? <Translate value="external-tooltip-text-fundability-scan-and-tax" /> : <Translate value="external-tooltip-text" />}
            </span>
        </>
    );
};

InfoTooltip.propTypes = {
    id: PropTypes.string.isRequired,
    ismobile: PropTypes.bool,
    openTooltipId: PropTypes.string,
    setOpenTooltipId: PropTypes.func.isRequired,
    isDashboard: PropTypes.bool.isRequired,
};

export default InfoTooltip;
